import { getDefinitionByName } from '@legacy-modules/common/util/kpiDefinitions';
import { PositiveDirection } from '@legacy-modules/metrics2/models/entities/PositiveDirection';

import ValueExpression from '@legacy-modules/valueexpressions/models/valueexpressions/ValueExpression';

export default new ValueExpression({
  identifier: 'lma-anomalies.usk.abholauftrag-nicht-abgeholt.count',
  label: 'Abholauftrag nicht abgeholt',
  positiveDirection: PositiveDirection.custom,
  definition: getDefinitionByName('Abholauftrag nicht abgeholt'),
  hidden: true,
});
